
import styles from "./SupportedControlsFilter.module.css"
import Pill from "@/components/UI/Buttons/Pill/Pill"
import { useTranslations } from "next-intl"
import { useState, useEffect } from "react";
import ImgEnjoyableKeyboard from "@/assets/img/Icon_Keyboard_Mouse.svg"
import ImgEnjoyableGamepad from "@/assets/img/Icon_Games.svg"
import ImgEnjoyableTouchscreen from "@/assets/img/Icon_Touchscreen.svg"

export default function SupportedControlsFilter({ update, resetSignal, initialData }: {
	update: (name: string, value: string) => void,
		resetSignal: number,
		initialData: string
	}) {
	// Constantes para los tipos de control
	const KEYBOARD = 1;
	const TOUCHSCREEN = 2;
	const GAMEPAD = 4;
	const t = useTranslations('Catalogue');

	// Estado para el valor bitmask de controles seleccionados
	const [selectedControls, setSelectedControls] = useState<number>(0);
	const [resetSignalState, setResetSignalState] = useState<number>(resetSignal)

	// Parsear initialData si viene con valor inicial (ej: "supportedControls=5")
	useEffect(() => {
		if (initialData && initialData !== '') {
			const match = initialData.match(/supported_controls=(\d+)/);
			if (match) {
				setSelectedControls(Number(match[1]));
			} else {
				setSelectedControls(0);
			}
		}
	}, [initialData]);

	useEffect(() => {
		if(resetSignal !== resetSignalState) {
			setResetSignalState(resetSignal)
			setSelectedControls(0)
		}
	}, [resetSignal])

	// Actualizar el filtro en el padre cuando cambia selectedControls
	useEffect(() => {
		if (selectedControls === 0) {
			update('supportedControls', '');
		} else {
			update('supportedControls', `supported_controls=${selectedControls}`);
		}
	}, [selectedControls]);

	// Handlers para togglear cada control
	function toggleKeyboard() {
		setSelectedControls(prev => prev ^ KEYBOARD);
	}
	function toggleTouchscreen() {
		setSelectedControls(prev => prev ^ TOUCHSCREEN);
	}
	function toggleGamepad() {
		setSelectedControls(prev => prev ^ GAMEPAD);
	}

	return (
		<div data-testid="SupportedControls">
			<h4 className={`bodyTextMedium ${styles.title}`} data-testid="SupportedControls_title">{t('supportedControlsTitle')}</h4>
			<div className={styles.filters} data-testid="SupportedControls_filters">
				<Pill
					checked={Boolean(selectedControls & KEYBOARD)}
					onClick={toggleKeyboard}
				>
					<ImgEnjoyableKeyboard />
					{t('supportedControlsKeyboard')}
				</Pill>
				<Pill
					checked={Boolean(selectedControls & GAMEPAD)}
					onClick={toggleGamepad}
				>
					<ImgEnjoyableGamepad />
					{t('supportedControlsGamepad')}
				</Pill>
				<Pill
					checked={Boolean(selectedControls & TOUCHSCREEN)}
					onClick={toggleTouchscreen}
				>
					<ImgEnjoyableTouchscreen />
					{t('supportedControlsTouch')}
				</Pill>
			</div>
		</div>
	);
}